import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { languages, Language } from './languages';

interface LanguageContextType {
  currentLang: string;
  setLanguage: (lang: string) => void;
  t: Language;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentLang, setCurrentLang] = useState<string>(() => {
    return localStorage.getItem('msl_lang') || 'en';
  });

  const setLanguage = (lang: string) => {
    if (languages[lang]) {
      setCurrentLang(lang);
      localStorage.setItem('msl_lang', lang);
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }
  };

  useEffect(() => {
    document.documentElement.lang = currentLang;
    document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
  }, [currentLang]);

  const t = languages[currentLang] || languages['zh'];

  return (
    <LanguageContext.Provider value={{ currentLang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
